import { useMutation } from "react-query";

import { asyncSendVideoSignatures } from "api/video";

type Options = {
  onError?: (error: unknown) => void;
  onSuccess?: (data: any) => void;
  onSettled?: () => void;
};

type VideoSignature = {
  videoId: string;
  startSignatureURL: string;
  taskId: number | null;
};

/**
 * This hook is used to update the video call signature.
 * PUT /video/{videoId}/customer-sign
 * @param {Options} options - The options for the hook.
 * @returns {Object} - The hook object.
 */
export const useUpdateVideoCallSignature = (options: Options) => {
  const { onSuccess, onError, onSettled } = options;

  const { mutate, isLoading, isError, ...rest } = useMutation(
    (signatures: VideoSignature) => asyncSendVideoSignatures(signatures),
    {
      onSuccess: (data) => {
        onSuccess?.(data);
      },
      onError: (error) => {
        console.error(error);
        onError?.(error);
      },
      onSettled: () => {
        onSettled?.();
      },
    }
  );

  return {
    updateVideoCallSignature: mutate,
    isUpdatingSignature: isLoading,
    isSignatureError: isError,
    ...rest,
  };
};

export default useUpdateVideoCallSignature;
